import { baseURL } from '..';
import { IEngine } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { IGetEnginePreviewResponse } from './iApiResponse';

const engineProvider = () => {
    const getEngineTemplatesAsync = async (): Promise<IResponse<IGetEnginePreviewResponse[]>> => httpClient.getAsync(createRequest(baseURL, '/Engine/GetEngineTemplates'), createHeaders());

    const getEngineByIdAsync = async (id: number): Promise<IResponse<IEngine>> => httpClient.getAsync(createRequest(baseURL, '/Engine/GetEngine', `?id=${id}`), createHeaders());

    const updateEngineWithImageAsync = async (payload: FormData): Promise<IResponse<IEngine>> =>
        httpClient.putAsync(createRequest(baseURL, '/Engine/UpdateEngineWithImage', undefined, payload), createHeaders('multipart/form-data'));

    const updateEngineAsync = async (payload: IEngine): Promise<IResponse<IEngine>> => httpClient.putAsync(createRequest(baseURL, '/Engine/UpdateEngine', undefined, payload), createHeaders());

    const insertEngineWithImageAsync = async (payload: FormData): Promise<IResponse<IEngine>> =>
        httpClient.postAsync(createRequest(baseURL, '/Engine/InsertEngineWithImage', undefined, payload), createHeaders('multipart/form-data'));

    const getAllEnginePreviewsAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IGetEnginePreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Engine/GetAllEnginePreviews', paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    const getEnginesByVesselAsync = async (vesselId: number, pageNumber?: number, pageSize?: number, filter?: string, withTests?: boolean): Promise<IResponse<IPaginatedResponse<IEngine>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Engine/GetEnginesByVessel', paginationQuery(pageNumber, pageSize, filter, withTests, vesselId)), createHeaders());

    const updateSelectedEnginesWithImageAndTranslationAsync = async (payload: FormData): Promise<IResponse> =>
        httpClient.putAsync(createRequest(baseURL, '/Engine/UpdateSelectedEnginesWithImageAndTranslation', undefined, payload), createHeaders('multipart/form-data'));

    return {
        updateSelectedEnginesWithImageAndTranslationAsync,
        getEnginesByVesselAsync,
        getEngineTemplatesAsync,
        updateEngineWithImageAsync,
        getAllEnginePreviewsAsync,
        getEngineByIdAsync,
        updateEngineAsync,
        insertEngineWithImageAsync,
    };
};

export default engineProvider();
